import { useEffect, useState } from "react";
import { useManageSuppliers } from "../../../hooks/suppliers/useManageSuppliers";
import { SelectField } from "melco-shared-logic";

export type ThreadSupplierSelectProps = {
    value: string;
    name: string;
    onChange: (value: string) => void;
}

export const ThreadPublishedSupplierSelect: React.FC<ThreadSupplierSelectProps> = ({
    value,
    name,
    onChange
}) => {
    const { data } = useManageSuppliers("published", "threads", 99999);

    const [suppliersData, setSuppliersData] = useState<any>();
    useEffect(() => { setSuppliersData(data) }, [data])
    const options = suppliersData?.map((s: any) => ({
        label: s.name,
        value: s.id
    })
    )
    // console.log(options)
    return (<>
        {data && <SelectField
            name={name}
            allowClear
            options={options}
            value={value}
            style={{ "width": "100%" }}
            onChange={(value: string) => { debugger; onChange(value) }}
        />
        }
    </>)
}